import EfProductNaver, { EfProductNaverItemProps } from '@elem/ui/ef-product-naver';
import { useRouter } from 'next/router';
import { useProductDispatch, useProductStore } from '../../ProductProvider';
import GetProductData from '../GetProductData';
import { useLang } from '@/i18n';
import { useMemo } from 'react';

export default function NavProduct() {
    const dispatch = useProductDispatch();
    const { locale = 'us' } = useRouter();
    const { t } = useLang('delta3series');
    const { t: tBundle } = useLang('delta3series.bundles');
    const { pageStatus, productPageData } = useProductStore();
    const { productSeries = [] } = productPageData;
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const IS_AU = locale === 'au';
    let tabs: EfProductNaverItemProps[] = [
        {
            key: 'Product',
            text: 'Product',
        },
        {
            key: 'Bundles',
            text: 'Bundles',
        },
        {
            key: 'Support',
            text: 'Support',
        },
        {
            key: 'Specs',
            text: 'Specs',
        },
        {
            key: 'Media',
            text: 'Media',
        },
    ];

    if (locale === 'jp') {
        tabs = [
            {
                key: 'Product',
                text: t('nav_tab1'),
            },
            // {
            //     key: 'Recycling',
            //     text: t('nav_tab2'),
            // },
            {
                key: 'Specs',
                text: t('nav_tab2'),
            },
            {
                key: 'Support',
                text: t('nav_tab3'),
            },
        ] as EfProductNaverItemProps[];
    }

    if (IS_EU_SITES) {
        tabs = [
            {
                key: 'Product',
                text: t('nav_tab1'),
            },
            {
                key: 'Support',
                text: t('nav_tab2'),
            },
            {
                key: 'Specs',
                text: t('nav_tab3'),
            },
        ] as EfProductNaverItemProps[];
    }

    if (IS_AU) {
        tabs = [
            {
                key: 'Product',
                text: t('nav_tab1'),
            },
            ...(pageStatus !== 'statusA'
                ? [
                      {
                          key: 'Bundles',
                          text: t('nav_tab2'),
                      },
                  ]
                : []),
            {
                key: 'Support',
                text: t('nav_tab3'),
            },
            {
                key: 'Specs',
                text: t('nav_tab4'),
            },
        ] as EfProductNaverItemProps[];
    }

    if (['br', 'mx'].includes(locale)) {
        tabs = [
            {
                key: 'Product',
                text: t('nav_tab1'),
            },
            {
                key: 'Support',
                text: t('nav_tab2'),
            },
            {
                key: 'Specs',
                text: t('nav_tab3'),
            },
        ];
    }

    let tCommonBuyText = t('nav_buy') || 'Buy Now';
    if (['statusB', 'statusC', 'statusD'].includes(pageStatus) && ['us'].includes(locale)) {
        tCommonBuyText = tBundle('btn_2');
    }
    const buyItem: EfProductNaverItemProps = {
        key: IS_EU_SITES || locale === 'mx' ? 'Buy' : 'Bundles',
        text: tCommonBuyText,
        url: productSeries[0]?.buyLink,
    };

    const itemCallback = (item: any) => {
        dispatch({
            type: 'changeProductTabActive',
            payload: item.key,
        });
        // 切换时划回顶部
        setTimeout(() => {
            const headerElem = document.querySelector('.ecoflow-frame-header');
            window.scrollTo({
                top: headerElem?.clientHeight,
                behavior: 'smooth', // 可选，平滑滚动
            });
        }, 100);
    };

    const callbackBuy = () => {
        if (!IS_EU_SITES && !['mx'].includes(locale)) {
            itemCallback(buyItem);
        }
    };

    // 自定义 buy now 按钮埋点
    const buyNowGtm = useMemo(() => {
        let gtmObj;
        if (IS_EU_SITES) {
            gtmObj = {
                event: 'uaEvent',
                event_name: 'buy',
                product_name: 'DELTA 3 SERIES',
                position: 'Product Detail_DELTA 3 SERIES',
            };
        } else if (IS_AU) {
            gtmObj = {
                event: 'uaEvent',
                event_name: 'product_navigation',
                navigation_name: buyItem.text,
                product_name: 'DELTA 3 Plus',
            };
        }

        return gtmObj;
    }, [IS_AU, IS_EU_SITES, buyItem.text]);

    return (
        <>
            <GetProductData />
            <EfProductNaver
                title={IS_EU_SITES && pageStatus === 'statusB' ? 'DELTA 3 SERIES' : 'DELTA 3 Plus'}
                tabs={tabs}
                hideBuy={(buyItem.key === 'Buy' && !buyItem.url) || (IS_AU && pageStatus === 'statusA')}
                buyNowGtm={buyNowGtm}
                buyItem={buyItem}
                callbackTab={itemCallback}
                callbackBuy={callbackBuy}
            />
        </>
    );
}
